var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathtub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 25.4584V29.375C41.125 33.7013 37.6179 37.2084 33.2917 37.2084H13.7083C9.3821 37.2084 5.875 33.7013 5.875 29.375V25.4584",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.9165,
    y: 21.5416,
    width: 39.1667,
    height: 3.91667,
    rx: 1.95833,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.708 37.2084V39.1667",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2915 37.2084V39.1667",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 21.5417V11.492C39.1665 9.68823 37.9915 6.54449 33.2915 8.39981",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3265 12.063C30.7511 12.7985 31.7204 13.0645 32.2825 12.4279V12.4279C32.6171 12.0489 32.8763 11.627 33.0453 11.1861C33.2143 10.7453 33.2898 10.2942 33.2675 9.85855C33.2452 9.42292 33.1255 9.0113 32.9153 8.6472C32.7051 8.2831 32.4084 7.97365 32.0423 7.73652C31.6762 7.49939 31.2478 7.33921 30.7815 7.26514C30.3152 7.19108 29.8202 7.20456 29.3248 7.30484V7.30484C28.4924 7.4733 28.2381 8.44579 28.6627 9.18128L29.4946 10.6221L30.3265 12.063Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.46875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtub);
export default __webpack_public_path__ + "static/media/bathtub.617f1fcb10e3b132cb546f5a7629a364.svg";
export { ForwardRef as ReactComponent };